var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.icons,"label":_vm.selectedItem.customized.next_icon
        ? _vm.icons.find((e) => e.icon == _vm.selectedItem.customized.next_icon).name
        : 'Seleccionar',"item-text":"name","item-value":"icon"},on:{"change":_vm.selectedImage},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('img',{attrs:{"width":"20","height":"20","src":require(`./assets/${item.icon}`)}}),_vm._v(" "+_vm._s(item.name)+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }